// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    UNITTYPE_DELETE_REQUEST,
} from 'Redux/actionTypes';

// Actions
import {
    unitTypeResult,
} from 'Redux/actions';

// Helpers
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* deleteUnitType({ payload }) {
    try {

        let QUERY = `
            mutation deleteUnitType ($id: Int!) {
                result: deleteUnitType (id: $id)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(unitTypeResult({ delete: data?.result }))
        } else yield put(unitTypeResult({ error: 'error-unit-type' }))

    } catch (exc) {
        yield put(unitTypeResult({ error: exc?.error }));
        ExceptionManager(exc, "Manufacturers/.components/unitTypesTab/.components/deleteUnitType/redux/saga", "deleteUnitType")
    }
}

function* watchMethods() {
    yield takeEvery(UNITTYPE_DELETE_REQUEST, deleteUnitType);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}